import { DefineModule } from 'vuex';
import { State, Getters, Actions, Mutations } from './types';

const moduleState: State = {
  query: null,
};

const storeModule: DefineModule<State, Getters, Mutations, Actions> = {
  state: moduleState,

  getters: {
    searchQuery: (state) => state.query,
    isSearchActive: (state) => state.query !== null,
  },

  actions: {
    search({ commit }, query) {
      commit('SEARCH', query);
    },
    searchShow({ commit }) {
      commit('SEARCH', '');
    },
    searchHide({ commit, state }) {
      if (state.query === null) return;

      commit('SEARCH', null);
    },
  },

  mutations: {
    SEARCH(state, query) {
      state.query = query;
    },
  },
};

export default storeModule;
